module.exports = __webpack_public_path__ + "img/newmodel_semisupervised.80884677.png";